import redCheck from "../redcheck.gif";
const google = (window as any).google;
const capitalise = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

class Logic {
  getUrlVars = () => {
    let vars: any[] = [],
      hash: any[] = [];
    const hashes = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&");
    for (let i = 0; i < hashes.length; i++) {
      hash = hashes[i].split("=");
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  };

  saveFilters = async () => {
    //object structure to pass to db
    // { username: 'string', filters: [{ name: 'string', state: Object }] }
    var query: any = this.getUrlVars();
    if (query.userId) {
      var username = query.userId;
      var obj = {
        username: username,
        filters: [
          {
            name: "controlState",
            state: (this as any)["controlState"].getState().selectedValues,
          },
          {
            name: "controlSite",
            state: (this as any)["controlSite"].getState().selectedValues,
          },
          {
            name: "controlType",
            state: (this as any)["controlType"].getState().selectedValues,
          },
          {
            name: "controlApplicant",
            state: (this as any)["controlApplicant"].getState().value,
          },
        ],
      };

      try {
        const update = await fetch(
          `https://avf-dashboard-api.azurewebsites.net/api/SaveFilters?username=${username}&filters=${JSON.stringify(
            obj.filters
          )}`,
          { method: "POST" }
        );
        const res = await update.json();
        if (res.success) {
          alert("Settings saved!");
        } else {
          alert("Unable to save settings");
        }
      } catch (ex) {
        alert(JSON.stringify(ex));
      }
    } else {
      alert("You must access this page from within VisualVault to save filters.");
    }
  };

  firstLoad = () => {
    const query: any = this.getUrlVars();
    let username, staticData;
    username = query.userId ? query.userId : "";
    Promise.all([
      fetch("https://avf-dashboard-api.azurewebsites.net/api/getData?queryid=6075b2f5-c5ef-e511-80cc-0050568dbd2f"),
      fetch(`https://avf-dashboard-api.azurewebsites.net/api/GetFilters?username=${username}`),
    ]).then(async (data) => {
      const res = await data[0].json();
      const table = await data[1].json();
      if (res.data.length) {
        staticData = res.data;
        this.drawGoogleTable(staticData, table);
      } else {
        alert(JSON.stringify(data));
      }
    });
  };

  drawGoogleTable = (rawData: any, dtt: any) => {
    let chartData = this.convertToDataTable(rawData);
    // Set Custom view properties/return values for columns with incorrect names etc
    let view = {
      columns: [
        {
          type: "string",
          label: "Form ID",
          calc: function (dt: any, row: any) {
            let val = dt.getValue(row, 0);
            return val;
          },
        },
        {
          type: "string",
          label: "Open",
          calc: (dt: any, row: any) => {
            const val = dt.getValue(row, 1);
            return `<div><a href="https://autotechfm.visualvault.com/App/NBNCo/Main/formdetails?DataID=${val}&hidemenu=true" target=_blank">Open</a><div />`;
          },
        },
        {
          type: "string",
          label: "Submitted",
          calc: (dt: any, row: any) => {
            let val;
            if (navigator.userAgent.indexOf("Chrome") > -1) {
              val = dt.getValue(row, 2) + "+11:00";
            } else {
              val = dt.getValue(row, 2);
            }
            const data = new Date(Date.parse(val));
            return data.toLocaleDateString("en-AU");
          },
        },
        3,
        4,
        5,
        6,
        7,
        {
          type: "string",
          label: "Scheduled",
          calc: (dt: any, row: any) => {
            const val = dt.getValue(row, 8);
            const data = new Date(val);
            return data.toLocaleDateString("en-AU");
          },
        },
        9,
        {
          type: "string",
          label: "To",
          calc: function (dt: any, row: any) {
            var val = dt.getValue(row, 10);
            var data = new Date(val);
            return data.toLocaleDateString("en-AU");
          },
        },
        11,
        12,
        13,
        {
          type: "string",
          label: "High Risk?",
          calc: function (dt: any, row: any) {
            var val = dt.getValue(row, 14);
            var returnString;
            if (val === "False" || val === "") {
              returnString = "";
            } else if (val === "True") {
              returnString = `<div><img src="${redCheck}" alt="High Risk" /></div>`;
            }
            return returnString;
          },
        },
        15,
        16,
        17,
        18,
      ],
    };
    var options = {
      chartArea: { left: 120, top: 50, height: "80%", width: "100%" },
      allowHtml: true,
      tooltip: { trigger: "both" },
      sort: "enable",
    };

    var tableChart = new google.visualization.ChartWrapper({
      containerId: "chart-div",
      chartType: "Table",
      dataTable: chartData,
      options: options,
      view: view,
    });

    var dashboard = new google.visualization.Dashboard(document.getElementById("dashboard_div"));

    (this as any)["controlState"] = new google.visualization.ControlWrapper({
      containerId: "control_state",
      controlType: "CategoryFilter",
      options: {
        filterColumnLabel: "State",
        ui: { caption: "Select State", label: "", labelSeparator: "" },
      },
    });
    (this as any)["controlSite"] = new google.visualization.ControlWrapper({
      containerId: "control_site",
      controlType: "CategoryFilter",
      options: {
        filterColumnLabel: "Site",
        ui: { caption: "Select Facility", label: "", labelSeparator: "" },
      },
    });
    (this as any)["controlType"] = new google.visualization.ControlWrapper({
      containerId: "control_type",
      controlType: "CategoryFilter",
      options: {
        filterColumnLabel: "Request Type",
        ui: { caption: "Select Type", label: "", labelSeparator: "" },
      },
    });
    (this as any)["controlApplicant"] = new google.visualization.ControlWrapper({
      containerId: "control_applicant",
      controlType: "StringFilter",
      options: {
        filterColumnLabel: "Applicant",
        ui: { caption: "Select Applicant", label: "", labelSeparator: "" },
      },
    });

    //Set Control Settings from Mongo
    if (dtt.filters !== undefined) {
      var filters = dtt.filters.filters;
      for (var o in filters) {
        switch (filters[o].name) {
          case "controlState":
            (this as any)["controlState"].setState({ selectedValues: filters[o].state });
            (this as any)["controlState"].draw();
            break;
          case "controlSite":
            (this as any)["controlSite"].setState({ selectedValues: filters[o].state });
            (this as any)["controlSite"].draw();
            break;
          case "controlType":
            (this as any)["controlType"].setState({ selectedValues: filters[o].state });
            (this as any)["controlType"].draw();
            break;
          case "controlApplicant":
            (this as any)["controlApplicant"].setState({ value: filters[o].state });
            (this as any)["controlApplicant"].draw();
            break;
          default:
            break;
        }
      }
    }

    const controls = [
      (this as any)["controlState"],
      (this as any)["controlSite"],
      (this as any)["controlType"],
      (this as any)["controlApplicant"],
    ];

    dashboard.bind(controls, tableChart);
    dashboard.draw(chartData);
  };

  convertToDataTable = (rawData: any) => {
    var chartData = new google.visualization.DataTable();
    var rowCount = rawData.length;
    if (rowCount > 0) {
      for (var rd in rawData[0]) {
        //POPULATE COLUMNS AND TYPE
        if (rawData[0].hasOwnProperty(rd)) chartData.addColumn(typeof rawData[0][rd], rd);
      }
      //POPULATE ROWS
      for (var i = 0; i < rowCount; i++) {
        var row = [];

        for (var prop in rawData[i]) {
          row.push(rawData[i][prop]);
        }
        chartData.addRows([row]);
      }
      // Capitalise Column Headings
      var numOfCols = chartData.getNumberOfColumns();
      for (var j = 0; j < numOfCols; j++) {
        var colLabel = chartData.getColumnLabel(j);
        colLabel = capitalise(colLabel);
        chartData.setColumnLabel(j, colLabel);
      }
      return chartData;
    } else {
      return null;
    }
  };
}

export default Logic;
